import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { dataURLtoFile } from "../utils/dataConverter";

class ReturnsApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);
  }

  public getTaxReturns = () => this.get("/tax_returns");

  public downloadTaxReturn = (id: number) => this.get(`/tax_return/${id}/pdf`, {
    responseType: 'blob'
  }) as Promise<Blob>;
  
}

export const returnsApi = new ReturnsApi(apiConfig);
